import { motion } from "framer-motion";
import { Disc3 } from "lucide-react";

export const Roster = ({ artists, tracks }) => (
  <section id="roster" className="relative py-28 border-t border-white/10 overflow-hidden">
    <div className="absolute -right-24 top-24 w-[420px] h-[420px] bg-[#00f0ff]/5 blur-[130px] rounded-full pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-14">
        <p className="font-mono-tech text-xs tracking-[0.35em] text-[#ff0055] uppercase mb-3">// The Roster</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase text-white">Artists on R-AN</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {artists.map((a, i) => {
          const releases = tracks.filter((t) => t.artist.toLowerCase() === a.name.toLowerCase());
          return (
            <motion.article
              key={a.id}
              data-testid={`artist-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className="group bg-[#0c0c12] hover:bg-[#101018] transition-colors"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                {a.photo_url ? (
                  <img src={a.photo_url} alt={`${a.name} portrait`} className="track-card-img w-full h-full object-cover" loading="lazy" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-[#101018] text-slate-700"><Disc3 size={40} /></div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#08080c] via-transparent to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-5">
                  <p className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[#00f0ff] mb-1">{a.genre}</p>
                  <h3 className="font-display text-xl font-bold text-white uppercase">{a.name}</h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-slate-400 leading-relaxed">{a.bio}</p>
                {releases.length > 0 && (
                  <div className="mt-4">
                    <p className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-slate-600 mb-2">On R-AN</p>
                    <div className="flex flex-wrap gap-2">
                      {releases.map((r) => (
                        <button
                          key={r.cat}
                          data-testid={`roster-release-${r.cat}`}
                          onClick={() => document.getElementById("releases")?.scrollIntoView({ behavior: "smooth" })}
                          className="inline-flex items-center gap-1.5 font-mono-tech text-[10px] tracking-wider uppercase px-2.5 py-1.5 border border-[#00ff66]/30 text-[#00ff66] hover:bg-[#00ff66] hover:text-black transition-colors"
                        >
                          <Disc3 size={10} /> {r.cat} — {r.title}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </motion.article>
          );
        })}
      </div>
    </div>
  </section>
);
